import { Company, User } from 'types';

const getUserType = (category?: string, company?: Company) => {
  // TODO: This feels uncomfortable, we should do better later
  let companyId = 'superadmin';
  if (category === 'buyer' && company && company?.id) {
    companyId = company.id.toString();
  }
  else if (category === 'vendor') {
    companyId = 'vendor';
  }

  return companyId;
};

// DataDog User Data
// We do not care about sending the role, isSelfServe, isDemoAccount, planType, timestamp
export const buildDatadogUserTrackingObject = (user: Partial<User>) =>({
  category: user.category,
  company_id: getUserType(user.category, user.company),
  email: user.email,
  id: user.id,
  is_superadmin_session: `${user.impersonating}`,
  name: `${user.first_name} ${user.last_name}`,
  organization_id: user.organization_id || 0,
  organization_name: user.organization_name || 'Arkestro System',
  superadmin_user: user.true_user,
});
